// Curated case studies — static fallback only. The website reads projects
// from the API (admin = source of truth). This file is used if the API call
// fails so the page never blanks out.
//
// Updated 2026-02-23: removed invented metrics and the "revenue intelligence
// SaaS" positioning of REVIX. Outcomes are now honest status descriptors.

export const WORK = [
  {
    slug: "revix",
    name: "REVIX",
    index: "01",
    category: "Automotive Platform",
    year: "2026",
    tagline: "Admin dashboard and storefront for performance automotive.",
    accent: "#E4FF00",
    tone: "#0a0a0a",
    challenge:
      "Performance and tuning shops still run their day between spreadsheets, marketplace listings and DM enquiries. There is no back-office that fits how this niche actually works — parts with vehicle-compatibility variants, made-to-order builds, and a customer who expects the shop to know what fits their car.",
    solution:
      "REVIX is an admin dashboard and customer-facing storefront built for performance automotive. A catalogue with vehicle-compatibility metadata, order and enquiry management, customer profiles, and a back-office the shop owner can actually run the business from — instead of stitching together five tools.",
    outcome: [
      { k: "Stage", v: "Concept" },
      { k: "Scope", v: "Storefront + Admin" },
      { k: "Type", v: "Portfolio build" },
    ],
    stack: ["React", "FastAPI", "MongoDB", "Python", "Stripe", "Tailwind"],
    services: ["Product design", "E-commerce", "Admin dashboard", "Platform engineering"],
    mock: "garage",
    screens: ["garage", "shop", "table"],
  },
  {
    slug: "leadforge",
    name: "LeadForge",
    index: "02",
    category: "AI System",
    year: "2026",
    tagline: "B2B lead generation and qualification with AI enrichment.",
    accent: "#E4FF00",
    tone: "#0a0a0a",
    challenge:
      "Sales teams burn hours every day chasing and qualifying leads in spreadsheets and LinkedIn. Data is fragmented, often outdated, and qualification ends up being subjective.",
    solution:
      "A web platform that imports lead sources, automatically enriches them with firmographic data using AI, and ranks contacts by who's actually worth contacting first. Sales reviews and approves instead of starting from scratch.",
    outcome: [
      { k: "Stage", v: "Live" },
      { k: "Scope", v: "Platform + AI" },
      { k: "Iteration", v: "Active" },
    ],
    stack: ["React", "FastAPI", "MongoDB", "OpenAI API", "Vector search", "Python"],
    services: ["AI architecture", "Backend engineering", "Dashboard", "Automation"],
    mock: "ai",
    screens: ["ai", "pipeline", "table"],
  },
  {
    slug: "bitwrex",
    name: "BitWrex",
    index: "03",
    category: "Crypto Exchange",
    year: "2025",
    tagline: "A clean three-step crypto swap experience.",
    accent: "#E4FF00",
    tone: "#0a0a0a",
    challenge:
      "Most crypto exchanges are unnecessarily complicated for everyday users — order books, derivatives, leverage. The goal was an interface where a swap is three clean steps.",
    solution:
      "A clean web app with a minimal swap interface, connected to a custom backend layer for pricing, KYC and transaction processing — designed so a first-time user can complete a swap without reading documentation.",
    outcome: [
      { k: "Stage", v: "In production" },
      { k: "Scope", v: "Frontend + Backend" },
      { k: "Iteration", v: "Long-term" },
    ],
    stack: ["React", "FastAPI", "Python", "MongoDB", "Stripe", "REST integrations"],
    services: ["UI/UX", "Platform engineering", "Payments", "Backend"],
    mock: "trading",
    screens: ["trading", "analytics", "dashboard"],
  },
  {
    slug: "serviscar",
    name: "SERVISCAR",
    index: "04",
    category: "Booking & E-commerce",
    year: "2026",
    tagline: "Booking and parts commerce for auto service.",
    accent: "#E4FF00",
    tone: "#0a0a0a",
    challenge:
      "Auto-service shops still take bookings over phone and paper. The result is double-booked slots, no visibility into capacity across locations, and no path to sell parts alongside the appointment.",
    solution:
      "A booking and e-commerce experience: real-time slot availability, parts catalogue with checkout, automated reminders and an operations dashboard the garage can run the day from.",
    outcome: [
      { k: "Stage", v: "Prototype" },
      { k: "Scope", v: "Booking + Shop + Admin" },
      { k: "Type", v: "Portfolio build" },
    ],
    stack: ["React", "FastAPI", "MongoDB", "Stripe", "Python", "Automation"],
    services: ["E-commerce", "Booking system", "Admin dashboard", "UI/UX"],
    mock: "booking",
    screens: ["booking", "shop", "dashboard"],
  },
];

export const WORK_BY_SLUG = WORK.reduce((acc, w) => {
  acc[w.slug] = w;
  return acc;
}, {});
